// extracted by mini-css-extract-plugin
export default {"expiredMessage":"Expired_expiredMessage__QJU7T","icon":"Expired_icon__61EO-","title":"Expired_title__mNt7W","text":"Expired_text__6AtXW","expired":"Expired_expired__EAmMD"};